import { IWorkEquipment } from "./actionTypes";
import { IState } from "./reducer";

export const helpers = (state: IState, payload: any) => {
  const set = (type: keyof IState): IState => {
    return {
      ...state,
      [type]: payload as IWorkEquipment[],
    };
  };

  const add = (type: keyof IState): IState => {
    const eq = payload as IWorkEquipment;
    return {
      ...state,
      [type]: [...state[type], eq],
    };
  };

  const edit = (type: keyof IState): IState => {
    const edited = payload as IWorkEquipment;
    const findIndex = state[type].findIndex((av) => av.id === edited.id);
    return {
      ...state,
      [type]: [
        ...state[type].slice(0, findIndex),
        edited,
        ...state[type].slice(findIndex + 1),
      ],
    };
  };

  const deleteEq = (type: keyof IState): IState => {
    const filtered = state[type].filter((av) => av.id !== (payload as string));
    return {
      ...state,
      [type]: filtered,
    };
  };

  return {
    set,
    create: add,
    edit,
    deleteEq,
  };
};
